import dxScrollView from "devextreme/ui/scroll_view";
import { createContext, useContext, useEffect, useState } from "react";

interface INavigationData {
	currentPath: string;
}

type NavigationContextType = {
	setNavigationData?: (data: INavigationData) => Promise<void>;
	navigationData: INavigationData;
	setTitle?: (title: string) => Promise<void>;
	title?: string;
	setScroll?: (scroll: dxScrollView) => Promise<void>;
	scrollToTop?: () => void;
};

const NavigationContext = createContext<NavigationContextType>({
	navigationData: { currentPath: "" },
});
const useNavigation = () => useContext(NavigationContext);

function NavigationProvider(props: any) {
	const [navigationData, setNavigationData] = useState({});
	const [title, setTitle] = useState("");
	const [scroll, setScroll] = useState<dxScrollView>();

	function scrollToTop() {
		scroll?.scrollTo({ top: 0 });
	}

	return (
		<NavigationContext.Provider
			value={{
				navigationData,
				setNavigationData,
				title,
				setTitle,
				setScroll,
				scrollToTop,
			}}
			{...props}
		/>
	);
}

function WithNavigationWatcher({ component, currentPath }: any) {
	const { setNavigationData } = useNavigation();

	useEffect(() => {
		if (setNavigationData) {
			setNavigationData({ currentPath });
		}
	}, [currentPath, setNavigationData]);

	return <>{component}</>;
}

export {
	NavigationContext,
	NavigationProvider,
	useNavigation,
	WithNavigationWatcher,
};
